// extracted by mini-css-extract-plugin
export default {"hideTooltip":"i--z","fadeIn":"j--z","delay":"k--z","recommendedSizeTooltip":"l--z"};